export default "__VITE_ASSET__DAqidAw8__"